const SKILLS_CONTENT = {
  pic: "https://i.imgur.com/ZduvM2w.jpeg",
};

export { SKILLS_CONTENT };
